// extracted by mini-css-extract-plugin
export default {"articles":"Services_articles__WyPPH","section":"Services_section__KnlE7"};